$(function () {

    // Datepicker
    $('.datepicker-solo').flatpickr({
        allowInput: true,
        clickOpens: true,
        locale: "fr",
        dateFormat: "d/m/Y",
        time_24hr: true,
        wrap: true
    });

    $("#btn_popupCalculatrice").click(function () {
        affichageDialogueBT("popupCalculatrice");
        return false;
    });

    $("#btn_calculDate").click(function () {
        var dateDeb;
        var dateFin;
        var messageErreur = "";

        $("#messageErreurCalculContenu").html("");
        $("#resultatCalculatriceContenu").html("");

        dateDeb = $('#dateDebutCalcul').val();
        dateFin = $('#dateFinCalcul').val();

        if (dateDeb == "")
            messageErreur += "La date de début doit être renseignée<br>";

        if (dateFin == "")
            messageErreur += "La date de fin doit être renseignée<br>";

        if (messageErreur == "") {
            var splitDateDeb = dateDeb.split("/");

            var yrDeb = splitDateDeb[2];
            var monthDeb = splitDateDeb[1];
            var dayDeb = splitDateDeb[0];
            dateDeb = yrDeb + '-' + monthDeb + '-' + dayDeb;

            var splitDateFin = dateFin.split("/");

            var yrFin = splitDateFin[2];
            var monthFin = splitDateFin[1];
            var dayFin = splitDateFin[0];
            dateFin = yrFin + '-' + monthFin + '-' + dayFin;

            if (dateFin < dateDeb)
                messageErreur += "La date de fin doit être supérieure à la date de début<br>";

            if (dateFin == dateDeb)
                messageErreur += "Les deux dates doivent être différentes<br>";

            if (messageErreur == "") {
                nombreMois = 1;

                var anneeDeb = parseInt(yrDeb);
                var anneeFin = parseInt(yrFin);
                var moisDeb = parseInt(monthDeb);
                var moisFin = parseInt(monthFin);
                var jourDeb = parseInt(dayDeb);
                var jourFin = parseInt(dayFin);

                if (anneeDeb < anneeFin) {
                    for (i = moisDeb; i <= 12; i++) {
                        nombreMois += 1;
                    }

                    for (i = anneeDeb + 1; i < anneeFin; i++) {
                        nombreMois += 12;
                    }

                    for (i = 1; i < moisFin; i++) {
                        nombreMois += 1;
                    }

                    if (jourDeb > jourFin) {
                        nombreMois -= 1;
                    }
                } else {
                    for (i = moisDeb; i < moisFin; i++) {
                        nombreMois += 1;
                    }

                    if (jourDeb > jourFin) {
                        nombreMois -= 1;
                    }
                }

                if (nombreMois > 1)
                    $("#resultatCalculatriceContenu").append(nombreMois + " mois comptables");
                else
                    $("#resultatCalculatriceContenu").append(nombreMois + " mois comptable");

                showElement("#resultatCalculatrice");
            }
        }

        if (messageErreur != "") {
            $("#messageErreurCalculContenu").append("<li>" + messageErreur + "</li>");
            showElement("#messageErreurCalcul");
        } else {
            hideElement("#messageErreurCalcul");
        }

        return false;
    });

});